// Reactive-forms validators and input-event helpers.

import {
  AbstractControl,
  FormGroup,
  ValidatorFn,
} from '@angular/forms';

export function serialNumberMatchValidator(
  control: AbstractControl,
): { [key: string]: boolean } | null {
  const serialNumber = control.get('serial_number')?.value;
  const serialNumber2 = control.get('serial_number2')?.value;

  if (serialNumber !== serialNumber2) {
    return { serialNumberMismatch: true };
  }

  return null;
}

export function passwordMatchValidator(
  control: AbstractControl,
): { [key: string]: boolean } | null {
  const password = control.get('password')?.value;
  const password2 = control.get('password2')?.value;

  if (password !== password2) {
    return { passwordMismatch: false };
  }

  return null;
}

export function checkPasswords(group: FormGroup) {
  if (group?.value) {
    let pass = group.get('password').value;
    let confirmPass = group.get('password2').value;
    return pass === confirmPass ? null : { notSame: true };
  } else {
    return null;
  }
}

export function usCurrencyValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const valid = /^\$?\d{1,3}(,?\d{3})*(\.\d{2})?$/.test(control.value);
    return valid ? null : { invalidCurrency: { value: control.value } };
  };
}

export function numberOnly(event): boolean {
  const charCode = event.which ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}

export function numberOnlyValidator(value: any): boolean {
  return /^\d+$/.test(value);
}

export function isValidFileType(
  file: File,
  allowedFileTypes: string[],
): boolean {
  const allowedExtensions = allowedFileTypes; //['csv', 'xlsx'];
  const fileExtension = file.name.split('.').pop()?.toLowerCase();
  return fileExtension ? allowedExtensions.includes(fileExtension) : false;
}
